import React from 'react';

const ComfortIcon = ({ backgroundFill, fillColor, strokeColor, strokeWidth, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      fill={backgroundFill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      width={width}
    >
      <circle cx="12" cy="17.8" r="2.2" fill={fillColor} stroke="none" />
      <path d="M12,1.1c-2.2,0-3.8,1.7-3.8,4v8.6c-1.1,1-1.7,2.4-1.7,3.9,0,3,2.4,5.5,5.5,5.5s5.5-2.4,5.5-5.5-.6-2.8-1.7-3.9V5.1c0-2.3-1.6-4-3.7-4h0Z" />
    </svg>
  );
};

export default ComfortIcon;
